import {Component, Input, OnInit, ViewChild} from '@angular/core';
import ArrayStore from 'devextreme/data/array_store';
import {SubReportComponent, SubReportElementComponent, SubReportFilter} from '../fields-interventions-general-ii-report.component';
import {DxChartComponent, DxPivotGridComponent} from 'devextreme-angular';
import PivotGridDataSource from 'devextreme/ui/pivot_grid/data_source';
import {Workbook, Worksheet} from 'exceljs';
import {durationToStr} from 'shared';
import {exportPivotGrid} from 'devextreme/excel_exporter';

@Component({
  selector: 'app-progression-speed',
  templateUrl: './progression-speed.component.html',
  styleUrls: ['./progression-speed.component.scss'],
  // tslint:disable-next-line:no-inputs-metadata-property
  inputs: SubReportComponent.inputs,
  // tslint:disable-next-line:no-outputs-metadata-property
  outputs: SubReportComponent.outputs,
})
export class ProgressionSpeedComponent extends SubReportComponent implements OnInit {

  constructor() {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.title = `${this.romainIndex}. La vitesse d'avancement du materiel de traction`.toUpperCase();

    // Raise the loaded event
    this.initialized.emit({
      index: this.index,
      export: workBook => this.export(workBook),
      loader: (isReload, filter, data) => this.load(isReload, filter, data)
    });
  }

  getWorkSheetName(): string {
    return this.title;
  }

}

/* -----------------------------------------
-- Table 1
-------------------------------------------- */
@Component({
  selector: 'app-progression-speed-table-1',
  template: `
    <dx-pivot-grid
      class="p-4"
      width="90%"
      [allowSortingBySummary]="true"
      [allowSorting]="true"
      [allowFiltering]="true"
      [allowExpandAll]="true"
      [showBorders]="true"
      [showColumnGrandTotals]="false">
      <dxo-header-filter
        [allowSearch]="true"
        [showRelevantValues]="true"
      ></dxo-header-filter>
      <dxo-field-chooser applyChangesMode="onDemand" [enabled]="true"></dxo-field-chooser>
      <dxo-export [enabled]="true"></dxo-export>

      <dxo-field-panel
        [showColumnFields]="false"
        [showRowFields]="false"
        [showDataFields]="false"
        [visible]="true">
      </dxo-field-panel>
    </dx-pivot-grid>

    <div class="p-4 flex items-center justify-center">
      <dx-chart class="self-center">

        <dxo-title horizontalAlignment="center" text="La vitesse d'avancement du materiel de traction" verticalAlignment="top">
          <dxo-font [weight]="300" [size]="20"></dxo-font>
        </dxo-title>

        <dxo-legend
          verticalAlignment="bottom"
          horizontalAlignment="center"
          itemTextPosition="right">
        </dxo-legend>

        <dxo-common-axis-settings>
          <dxo-grid [visible]="true"></dxo-grid>
        </dxo-common-axis-settings>

        <dxo-export [enabled]="true"></dxo-export>

        <dxo-zoom-and-pan
          [dragToZoom]="true"
          valueAxis="none"
          argumentAxis="both"
        ></dxo-zoom-and-pan>

        <dxo-tooltip
          [enabled]="true"
          [customizeTooltip]="customizeTooltip">
        </dxo-tooltip>

        <dxo-common-series-settings type="bar">
          <dxo-label
            [visible]="true"
            [format]="{
                type: 'fixedPoint',
                precision: '0'
            }">
          </dxo-label></dxo-common-series-settings>
        <dxo-size [height]="500" [width]="800"></dxo-size>
      </dx-chart>
    </div>
  `,
  // tslint:disable-next-line:no-inputs-metadata-property
  inputs: SubReportElementComponent.inputs,
  // tslint:disable-next-line:no-outputs-metadata-property
  outputs: SubReportElementComponent.outputs,
})
export class ProgressionSpeedTable1Component extends SubReportElementComponent implements OnInit {

  @ViewChild(DxChartComponent, {static: false})
  chart: DxChartComponent;

  @ViewChild(DxPivotGridComponent, {static: false})
  pivotGrid: DxPivotGridComponent;

  ds: PivotGridDataSource;

  constructor() {
    super();
  }

  ngOnInit(): void {
    // Raise the loaded event
    this.initialized.emit({
      index: this.index,
      export: (workBook, workSheet, topLeftCell) => this.export(workBook, workSheet, topLeftCell),
      loader: (isReload, filter, data) => this.load(isReload, filter, data),
    });
  }

  export(workBook: Workbook, workSheet: Worksheet, topLeftCell): Promise<any> {
    return exportPivotGrid({
      component: this.pivotGrid.instance,
      worksheet: workSheet,
      topLeftCell
    });
  }

  load(isReload: boolean, filter: SubReportFilter, d) {
    const ids = filter.domainIds();
    const ff = (item) => {
      return ids.indexOf(item.field.domain_id) !== -1;
    };

    if (isReload) {
      this.ds.filter(ff);
      this.ds.reload();
      return;
    } else {
      this.ds = new PivotGridDataSource({
        fields: [{
          caption: 'BU',
          width: 120,
          dataField: 'business_unit_name',
          allowFiltering: true,
          area: 'filter',
        }, {
          caption: 'Domaine',
          width: 120,
          dataField: 'domain_name',
          allowFiltering: true,
          area: 'filter',
        }, {
          caption: 'Operation',
          dataField: 'trailer_operation_type',
          allowFiltering: true,
          area: 'row'
        }, {
          caption: 'Tracteur',
          dataField: 'tractor_name',
          allowFiltering: true,
          area: 'row'
        }, {
          caption: 'Outil',
          dataField: 'trailer_name',
          allowFiltering: true,
          area: 'row'
        }, {
          caption: 'Campagne',
          dataField: 'start_time',
          dataType: 'date',
          selector: (data) => {
            const date = new Date(data.start_time);
            const year = date.getFullYear();
            const month = date.getMonth();
            if (month >= 10) {
              return 'Campagne ' + year;
            }
            return 'Campagne ' + (year - 1);
          },
          area: 'column'
        }, {
          caption: 'Vitesse moyenne au travail km/h',
          dataField: 'working_in_field_speed_avg',
          dataType: 'number',
          summaryType: 'avg',
          format: {type: 'fixedPoint', precision: 2},
          area: 'data'
        }, {
          caption: 'Vitesse maximale au travail km/h',
          dataField: 'working_in_field_speed_max',
          dataType: 'number',
          summaryType: 'max',
          format: {type: 'fixedPoint', precision: 2},
          area: 'data'
        }],
        filter: ff,
        store: this.store,
        retrieveFields: false,
      });
      // this.ds.filter(['field.domain_id', '=', filter.domainIds()]);
    }

    this.pivotGrid.instance.bindChart(this.chart.instance, {
      dataFieldsDisplayMode: 'singleAxis',
      inverted: true,
      alternateDataFields: false,
      customizeSeries: (seriesName, seriesOptions) => {
        return seriesOptions; // This line is optional
      },
      customizeChart: (chartOptions) => {
        chartOptions.valueAxis[0].label = {
          customizeText: (args) => {
            return args.value.toFixed(2) + ' km/h';
          }
        };
        return chartOptions; // This line is optional
      },
    });

    // Assign the data source
    this.pivotGrid.instance.option('dataSource', this.ds);

    return Promise.resolve(undefined);
  }

  customizeTooltip(args) {
    return {
      html: args.seriesName + ': ' + args.originalValue.toFixed(2) + ' km/h'
    };
  }
}
